<template>
	<div class="top">
		<div class="middle-row around" style="background-color: #f5f5f5;width: 100%;">
			<h3 style="padding: 10px 5px;width: 20%;">{{ title }}</h3>
			<div class="middle-row center" style="width:45%;">
				<div class="input-group" style="margin: 5px">
					<input type="text" class="form-control" placeholder="请输入商户名称或者设备编号" v-model="searchKey" size="30">
				</div>
				<button class="btn btn-danger" @click="search" data-toggle="modal" data-target="#merchant"><i
						class="fa fa-search"></i>&nbsp;搜索设备</button>
			</div>
			<div class="middle-row center" style="width: 35%;">
				<div class="input-group" style="margin: 5px">
					<input type="text" id="start" class="form-control">
					<span class="input-group-addon">查询时间段</span>
				</div>
			</div>
			<button class="btn btn-primary" @click="queryByTime" style="margin-right: 15px;"><i
					class="fa fa-search"></i>&nbsp;开始查询</button>
		</div>
		<div style="width: 100%;">
			<div v-show="showResult">
				<div class="middle-row between">
					<h3 style="margin: 25px !important;" class="middle-row">{{ merchant.merchantName }}<span
							class="badge bg-green" style="margin-left: 10px;">共{{ listtotal }}条记录</span><button
							style="margin-left: 10px;" href="" class="btn btn-warning btn-sm"
							@click="toExcel">导出Excel</button></h3>
					<div class="middle-row between" v-show="afterquery">
						<ul class="pagination pagination" v-if="pagetotal <= 5">
							<li><a href="#" @click="tofirst">首页</a></li>
							<li><a href="#" @click="laquo">&laquo;</a></li>
							<li v-for="n in pagetotal" :key="n"><a href="#" @click="pageClick(n)">{{ n }}</a></li>
							<li><a href="#" @click="raquo">&raquo;</a></li>
							<li><a href="#" @click="tolast">尾页</a></li>
						</ul>

						<ul class="pagination pagination" v-if="pagetotal >= 6">
							<li><a href="#" @click="tofirst">首页</a></li>
							<li><a href="#" @click="laquo">&laquo;</a></li>
							<li><a href="#" @click="pageClick(1)">1</a></li>
							<li><a href="#" @click="pageClick(2)">2</a></li>
							<li><a href="#">...</a></li>
							<li><a href="#" @click="pageClick(pagetotal - 1)">{{ pagetotal - 1 }}</a></li>
							<li><a href="#" @click="pageClick(pagetotal)">{{ pagetotal }}</a></li>
							<li><a href="#" @click="raquo">&raquo;</a></li>
							<li><a href="#" @click="tolast">尾页</a></li>
						</ul>
						<span style="margin-left: 10px;">共<b>{{ pagetotal }}</b>页，当前第<b>{{ pageindex + 1
								}}</b>页，转跳至第<input type="text" v-model="topage" @keydown.enter="skipto"
								style="margin: 5px;text-align: center;" size="1" /> 页</span>
					</div>
				</div>
				<table class="table table-condensed" style="background-color: white;">
					<thead>
						<tr>
							<th v-for="(item, n) in th" :key="n">{{ item }}</th>
						</tr>
					</thead>
					<tbody>
						<tr v-if="java == 'Lampblack'" v-for="(value, n) in resultlist" :key="n">
							<td>{{ value.equId }}</td>
							<td v-if="value.lc > 2">{{ value.lc }} <img src="/api/gantanhao.png" title="油烟浓度超标，阀值为：2" style="width: 14px;height: 14px;" /> </td>
							<td v-else>{{ value.lc }}</td>
							<td>{{ value.pc }}</td>
							<td>{{ value.nmthc }}</td>
							<td>{{ value.time }}</td>
							<td>{{ value.state }}</td>
						</tr>
						<tr v-if="java == 'OutDoor'" v-for="(value, n) in resultlist" :key="n">
							<td>{{ value.equId }}</td>
							<td>{{ value.vocs }}</td>
							<td>{{ value.time }}</td>
							<td>{{ value.state }}</td>
						</tr>
						<tr v-if="java == 'CarRepair'" v-for="(value, n) in resultlist" :key="n">
							<td>{{ value.equId }}</td>
							<td>{{ value.bz }}</td>
							<td>{{ value.bzs }}</td>
							<td>{{ value.nmthc }}</td>
							<td>{{ value.temp }}</td>
							<td>{{ value.pc }}</td>
							<td>{{ value.time }}</td>
							<td>{{ value.state }}</td>
						</tr>
						<tr v-if="java == 'Dust'" v-for="(value, n) in resultlist" :key="n">
							<td>{{ value.equId }}</td>
							<td>{{ value.pm25 }}</td>
							<td>{{ value.pm10 }}</td>
							<td>{{ value.noise }}</td>
							<td>{{ value.temp }}</td>
							<td>{{ value.humidity }}</td>
							<td>{{ value.wp }}</td>
							<td>{{ value.wd }}</td>
							<td>{{ value.ws }}</td>
							<td>{{ value.time }}</td>
							<td>{{ value.state }}</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div style="width: 100%;height: 500px;" class="middle-row center" v-show="!showResult">
				<img src="../../static/images/timg.gif" alt="">
			</div>
		</div>
		<div class="modal fade" id="merchant" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
			aria-hidden="true">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
						<h4 class="modal-title" id="myModalLabel">{{ info }}</h4>
					</div>
					<table class="table " v-if="showTable">
						<thead>
							<tr>
								<th>编号</th>
								<th>设备编号</th>
								<th>商户名称</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(mer, n) in merchants" :class="index == n ? 'active' : ''"
								@click="selectMerchant(n)" :key="n">
								<td>{{ n + 1 }}</td>
								<td>{{ mer.equNum }}</td>
								<td>{{ mer.merchantName }}</td>
							</tr>
						</tbody>
					</table>
					<div class="modal-footer">
						<button type="button" class="btn btn-default" data-dismiss="modal">关闭</button>
						<button type="button" class="btn btn-primary" @click="confirm"
							:disabled="!showTable">选择</button>
					</div>
				</div><!-- /.modal-content -->
			</div><!-- /.modal -->
		</div>
	</div>
</template>

<script>
import { util } from '../../static/util.js'
export default {
	data() {
		return {
			index: 1, //模态框选择商户
			searchKey: '', //搜索关键字
			merchants: [], //商户列表
			merchant: '', //当前商户
			start: '', //查询开始时间
			end: '', //查询结束时间
			info: '搜索结果', //模态框标题
			showTable: true, //是否显示表格
			th: [], //表格第一行标题数组
			way: '', //查询路径
			timeway: '',
			showResult: false, //是否显示图片或者查询结果
			java: '', //对应的java类
			resultlist: [], //查询结果数组
			bodyname: '', //查询结果的类型，用于获取body内的数据
			items: [ //th标题组
				['设备编号', '油烟浓度', '颗粒物浓度', '非甲烷总烃', '监测时间', '设备状态'],
				['设备编号', 'VOCS排放', '监测时间', '设备状态'],
				['设备编号', 'pm2.5', 'pm10', '噪声', '温度', '湿度', '风力', '风向', '风速', '监测时间', '设备状态'],
				['设备编号', '苯', '苯系物', '非甲烷总烃', '温度', '颗粒物', '监测时间', '设备状态']
			],
			engfiles: [
				['equId', 'lc', 'pc', 'nmthc', 'time', 'state'],
				['equId', 'vocs', 'time', 'state'],
				['equId', 'pm25', 'pm10', 'noise', 'temp', 'humidity', 'ws', 'wp', 'wd', 'time', 'state'],
				['equId', 'bz', 'bzs', 'nmthc', 'temp', 'pc', 'time', 'state']
			],
			files: [],
			pageindex: 0, //当前页面编号
			pagesize: 20, //单页面显示数量
			listtotal: 0, //查询结果总数
			pagetotal: 0, //查询页面总数
			topage: 1, //转跳至第几页
			afterquery: false, //查询结果出来后显示
			title: '详细数据查询'
		}
	},
	methods: {
		search: function () {
			if (!this.searchKey || this.searchKey == '') {
				this.info = '请输入搜索关键字';
				this.showTable = false;
			} else {
				this.$http.post(this.GLOBAL.base + 'searchMerchant', {
					like: this.searchKey
				}, {
					emulateJSON: true
				}).then(function (res) {
					this.merchants = res.body;
					if (!this.merchants) {
						this.info = '未查找到相关监控点';
						this.showTable = false;
					}
					this.info = '共搜索出以下结果';
					this.showTable = true;
				})
			}
			return true;
		},
		selectMerchant: function (n) {
			this.index = n;
			this.merchant = this.merchants[n];
			this.showResult = true;
			this.switchMerchant();
			this.resultlist = '';
			return true;
		},
		confirm: function () {
			$("#merchant").modal("hide");
			this.searchKey = '';
		},
		queryByTime: function () {
			console.log(this.merchant, this.start, this.end)
			if (!this.merchant || !this.start || !this.end) {
				alert('请输入完整信息')
			} else {
				this.$http.get(this.GLOBAL.base + this.way, {
					params: {
						start: this.start,
						end: this.end,
						equId: this.merchant.equNum,
						pageindex: this.pageindex,
						pagesize: this.pagesize
					}
				}).then(function (res) {
					this.resultlist = res.body[this.bodyname];
					if (!this.resultlist || this.resultlist.length == 0) {
						alert('所选时间段内无监测数据')
					} else {
						this.listtotal = res.body.limit; //监测数据总量
						var date = new Date()
						for (let res of this.resultlist) {
							date.setTime(res.time);
							res.time = (date.getMonth() + 1) + '月' + date.getDate() + '日 ' + date.getHours() + '时' + date.getMinutes() +
								'分';
							if (res.state == 'offline') {
								res.state = '离线';
							} else {
								res.state = '运行中';
							}
						}
						this.afterquery = true;
						this.setPage();
					}
				})
			}
		},
		setPage: function () {
			var i = this.listtotal / 20;
			if (i % 1 == 0) {
				this.pagetotal = i;
			} else {
				this.pagetotal = Math.ceil(i);
			}
		},
		pageClick: function (n) {
			this.topage = n;
			this.skipto();
		},
		skipto: function () { //跳转至指定页面
			var numReg = /^[0-9]*$/
			var numRe = new RegExp(numReg)
			if (!numRe.test(this.topage)) {
				alert('请输入正确的数字');
				return;
			}
			if (this.topage < 0 || this.topage > this.pagetotal) {
				alert("请输入正确的页码范围");
				return;
			}
			if (this.topage == this.pageindex + 1) {
				return;
			}
			this.pageindex = this.topage - 1;
			this.pageable();
		},
		laquo: function () {
			if (this.pageindex == 0) {
				return
			} else {
				this.pageindex--;
				this.pageable();
			}
		},
		raquo: function () {
			if (this.pageindex > this.pagetotal - 1) {
				return
			} else {
				this.pageindex++;
				this.pageable();
			}
		},
		pageable: function () {
			this.$http.get(this.GLOBAL.base + this.way, {
				params: {
					start: this.start,
					end: this.end,
					type: this.java,
					equId: this.merchant.equNum,
					pageindex: this.pageindex,
					pagesize: this.pagesize
				}
			}).then(function (res) {
				this.resultlist = res.body[this.bodyname];
				if (!this.resultlist || this.resultlist.length == 0) {
					alert("24小时内没有监测值");
					return;
				}
				var date = new Date()
				for (let res of this.resultlist) {
					date.setTime(res.time);
					res.time = (date.getMonth() + 1) + '月' + date.getDate() + '日 ' + date.getHours() + '时' + date.getMinutes() +
						'分';
					if (res.state == 'offline') {
						res.state = '离线';
					} else {
						res.state = '运行中';
					}
				}
			})
		},
		tofirst: function () {
			if (this.pageindex == 0) {
				return;
			}
			this.pageindex = 0;
			this.pageable();
		},
		tolast: function () {
			if (this.pageindex == this.pagetotal) {
				return;
			}
			this.pageindex = this.pagetotal - 1;
			this.pageable();
		},
		switchMerchant: function () {
			switch (this.merchant.equType) {
				case '餐饮油烟排放':
					this.way = 'queryLampblackLimited';
					this.timeway = 'lampblackTimeable';
					this.java = 'Lampblack';
					this.th = this.items[0];
					this.bodyname = 'lampblacks';
					this.files = this.engfiles[0]
					break;
				case 'VOCS排放':
					this.way = 'queryOutDoorLimited';
					this.timeway = 'outdoorTimeable';
					this.java = 'OutDoor';
					this.th = this.items[1];
					this.bodyname = 'outerDoors';
					this.files = this.engfiles[1]
					break;
				case '工地扬尘':
					this.way = 'queryDustLimited';
					this.timeway = 'dustTimeable';
					this.java = 'Dust';
					this.th = this.items[2];
					this.bodyname = 'dusts';
					this.files = this.engfiles[2]
					break;
				case '工业企业废气':
					this.way = 'queryCarRepairLimited';
					this.timeway = 'carRepairTimeable';
					this.java = 'CarRepair';
					this.th = this.items[3];
					this.bodyname = 'carRepairs';
					this.files = this.engfiles[3]
					break;
			};
			return true;
		},
		toExcel: function () {
			if (!this.merchant || !this.start || !this.end) {
				alert('请输入完整信息');
				return;
			}
			var option = {};
			option.fileName = this.merchant.merchantName + '监控数据表';
			this.$http.get(this.GLOBAL.base + this.timeway, {
				params: {
					start: this.start,
					end: this.end,
					equId: this.merchant.equNum,
				}
			}).then(function (msg) {
				if (msg.body.length == 0) {
					alert('所选时间段无数据');
					return;
				}
				for (let target of msg.body) {
					target.time = util.timeToStringWithYear(target.time)
				}
				option.datas = [{
					sheetData: msg.body,
					sheetName: this.merchant.merchantName,
					sheetHeader: this.th,
					sheetFilter: this.files
				}];
				var toExcel = new ExportJsonExcel(option);
				toExcel.saveExcel();
			})
		}
	},
	mounted() {
		var that = this;
		laydate.render({
			elem: '#start', //指定元素.
			type: 'datetime',
			range: true,
			format: 'yyyy-MM-dd HH:mm:ss',
			done: function (value, startData, endData) {
				const startDate = new Date(startData.year, startData.month - 1, startData.date, startData.hours, startData.minutes, startData.seconds);
				const endDate = new Date(endData.year, endData.month - 1, endData.date, endData.hours, endData.minutes, endData.seconds);
				that.start = startDate.getTime();
				that.end = endDate.getTime();
				that.title = '时间段查询';
			}
		});
		//获取主页传来的商户对象
		var mer = this.$route.query.mer
		if (mer) {
			this.searchKey = mer.equId;
			this.$http.post(this.GLOBAL.base + 'searchMerchant', {
				like: this.searchKey
			}, {
				emulateJSON: true
			}).then(function (res) {
				this.merchants = res.body;
				this.selectMerchant(0);
				this.start = new Date().valueOf() - 24 * 3600000;
				this.end = new Date().valueOf();
				this.pageindex = 0;
				this.queryByTime();
				this.title = '24小时内指标';
			})
		}
	}
}
</script>

<style>
.active {
	background-color: #F5F5F5;
}
</style>
